import React from 'react'
import {withTheme} from 'styled-components'
import {getLocationSetter} from 'utils/browserUtils'
import config from 'config'
import {ELEMENTS_IDS} from 'const'

import Logo from './Logo'
import {LogosView, InnerLogosView, AdditionalIconsView} from './LogosView'

const HeaderLogos = ({theme}) => (
  <LogosView>
    <InnerLogosView>
      <Logo
        className={ELEMENTS_IDS.brandLogo}
        src={`${config.url}/assets/${theme.shell.header.icon.image}`}
        icon={theme.shell.header.icon}
        onClick={getLocationSetter(theme.shell.header.icon.href)}
      />
    </InnerLogosView>
    <AdditionalIconsView>
      {theme.shell.header.additionalIcons?.map(icon => (
        <Logo
          className={ELEMENTS_IDS.brandLogo}
          key={icon.image}
          icon={icon}
          src={`${config.url}/assets/${icon.image}`}
          onClick={getLocationSetter(icon.href)}
        />
      ))}
    </AdditionalIconsView>
  </LogosView>
)

export default withTheme(HeaderLogos)
